export type ThemeMode = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'kincode-theme';

/**
 * Read persisted theme from localStorage; defaults to dark when unset.
 * @returns {ThemeMode}
 */
export function readStoredTheme(): ThemeMode {
  if (typeof window === 'undefined') {
    return 'dark';
  }

  const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
  return saved === 'light' ? 'light' : 'dark';
}

/**
 * Apply theme class on `<html>` for Tailwind `darkMode: 'class'`.
 * @param {ThemeMode} theme
 */
export function applyThemeClass(theme: ThemeMode): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.classList.remove('light', 'dark');
  document.documentElement.classList.add(theme);
}
